import React, { useState, useEffect, ReactNode } from 'react';

type ButtonSliderProps = {
  buttonItems: { name: string, icon?: ReactNode }[];
  onButtonClick: ( index: number ) => void;
  baseClassName?: string;
  textColor?: string;
  activeTextColor?: string;
  sliderBg?: string;
  borderArrowColor?: string;
  selectedIndex?: number;
  icon?: ReactNode
};

const ButtonSlider: React.FC<ButtonSliderProps> = ( {
  buttonItems,
  onButtonClick,
  baseClassName = 'bg-gray-200',
  textColor = 'text-black',
  activeTextColor = 'text-gray-base',
  sliderBg = 'bg-app-color',
  selectedIndex,
} ) => {
  const [ activeIndex, setActiveIndex ] = useState( selectedIndex ?? 0 );
  const sliderWidth = `${100 / buttonItems.length}%`;

  useEffect( () => {
    if ( selectedIndex !== undefined && selectedIndex !== activeIndex ) {
      setActiveIndex( selectedIndex );
    }
  }, [ selectedIndex ] );

  useEffect( () => {
    if ( activeIndex >= buttonItems.length ) {
      setActiveIndex( 0 );
      onButtonClick( 0 );
    }
  }, [ buttonItems, activeIndex, onButtonClick ] );

  const handleMenuClick = ( index: number ) => {
    setActiveIndex( index );
    onButtonClick( index );
  };

  if ( buttonItems.length === 0 ) {
    return null;
  }

  return (
    <>
      <div className={`relative rounded-md group py-1 ${baseClassName}`}>
        <div className='relative flex justify-between items-center'>
          {buttonItems.map( ( item, index ) => {return (
            <button
              key={index}
              className={`w-full max-sm:text-sm md:text-xl lg:text-2xl flex-1 text-center transition duration-300 ease-in-out z-10 flex justify-center items-center gap-x-2
            ${activeIndex === index ? activeTextColor : textColor}`}
              onClick={() => {return handleMenuClick( index );}}
            >
              {item.icon}
              {item.name}
            </button>
          );} )}

          {/*--------Div Absolute -----------*/}
          <div
            className={'absolute h-[100%] px-1 trans-fast flex-center'}
            style={{
              left: `${activeIndex * ( 100 / buttonItems.length )}%`,
              width: sliderWidth,
            }}
          >
            <div className={`w-full h-full rounded-md ${sliderBg}`} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ButtonSlider;
